<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="systemBox">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="大模型Token设置" name="first">
          <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
            <div class="audit">
              <el-form-item label="" prop="isLimitation">
              <span class="messageNumber-desc topMargin">Token数：</span>
                <el-select v-model="ruleForm.isLimitation" class="maxNumber" @change="changeMaxNumber">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-form-item prop="tokenMax" class="isMaxNumber messageNumber">
                  <el-input v-model.number="ruleForm.tokenMax" placeholder="输入Token数" :disabled="ruleForm.isLimitation"></el-input><span class="valueCss"> Tokens参考值：1元=10万Tokens</span>
                </el-form-item>
              </el-form-item>
            </div>

            <div class="audit" style="margin-bottom: 10px;">
              <span class="messageNumber-desc">余额预警：</span>
                <el-form-item prop="tokenWarn" class="isMaxNumber messageNumber">
                  低于 <el-input v-model.number="ruleForm.tokenWarn" placeholder="输入预警值" :disabled="ruleForm.isLimitation"></el-input> Tokens
                </el-form-item>
            </div>

            <div class="audit">
              <el-form-item>
                <el-button type="primary" @click="submitForm" style="margin-left: 70px;">保存设置</el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="智能体Token设置" name="second">
          <el-form :model="ruleForm1" ref="ruleForm1" class="demo-ruleForm">
            <div class="audit">
              <el-form-item label="" prop="isLimitation">
              <span class="messageNumber-desc topMargin">Token数：</span>
                <el-select v-model="ruleForm1.isLimitation" class="maxNumber" @change="changeMaxNumber1">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-form-item prop="tokenMax" class="isMaxNumber messageNumber">
                  <el-input v-model.number="ruleForm1.tokenMax" placeholder="输入Token数" :disabled="ruleForm1.isLimitation"></el-input><span class="valueCss"> Tokens参考值：1元=10万Tokens</span>
                </el-form-item>
              </el-form-item>
            </div>

            <div class="audit" style="margin-bottom: 10px;">
              <span class="messageNumber-desc">余额预警：</span>
                <el-form-item prop="tokenWarn" class="isMaxNumber messageNumber">
                  低于 <el-input v-model.number="ruleForm1.tokenWarn" placeholder="输入预警值" :disabled="ruleForm1.isLimitation"></el-input> Tokens
                </el-form-item>
            </div>

            <div class="audit">
              <el-form-item>
                <el-button type="primary" @click="submitForm1" style="margin-left: 70px;">保存设置</el-button>
              </el-form-item>
            </div>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
export default {
  name:"finance",
  data() {
    return {
      activeName: "first",
      options: [
        {
          value: false,
          label: "限制",
        },
        {
          value: true,
          label: "不限制",
        },
      ],
      ruleForm: {
        isLimitation: false,
        tokenMax: "",
        tokenWarn: "",
      },
      ruleForm1: {
        isLimitation: false,
        tokenMax: "",
        tokenWarn: "",
      },
      tmpTokenMax : "",
      tmpTokenWarn : "",
      tmpTokenMax1 : "",
      tmpTokenWarn1 : "",
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$api.system.tokenListFn().then((res) => {
        if(res.code == 1){
          if(!res.data || res.data.length == 0){
            this.ruleForm.isLimitation = true;
            this.ruleForm.tokenMax = 0;
            this.ruleForm.tokenWarn = 0;
            this.tmpTokenMax = 0;
            this.tmpTokenWarn = 0;
            this.ruleForm1.isLimitation = true;
            this.ruleForm1.tokenMax = 0;
            this.ruleForm1.tokenWarn = 0;
            this.tmpTokenMax1 = 0;
            this.tmpTokenWarn1 = 0;
            return;
          }
          res.data.forEach(e=>{
            if(e.setType == 'deepseek'){
              if(e.setName == "tokenMax"){
                this.ruleForm.tokenMax = e.setValue;
                this.tmpTokenMax = e.setValue;
                this.ruleForm.isLimitation = this.ruleForm.tokenMax ? false : true;
              }
              if(e.setName == "tokenWarn"){
                this.ruleForm.tokenWarn = e.setValue;
                this.tmpTokenWar = e.setValue;
              }
            }
            if(e.setType == 'agent'){
              if(e.setName == "tokenMax"){
                this.ruleForm1.tokenMax = e.setValue;
                this.tmpTokenMax1 = e.setValue;
                this.ruleForm1.isLimitation = this.ruleForm1.tokenMax ? false : true;
              }
              if(e.setName == "tokenWarn"){
                this.ruleForm1.tokenWarn = e.setValue;
                this.tmpTokenWar1 = e.setValue;
              }
            }
          })
        }
      });
    },
    submitForm() {
      if(this.ruleForm.isLimitation){
        this.ruleForm.tokenMax = 0;
        this.ruleForm.tokenWarn = 0;
      }else{
        if(!this.ruleForm.tokenMax){
          this.$message.error("请输入Token数");
          return;
        }
        if(!this.ruleForm.tokenWarn){
          this.$message.error("请输入预警值");
          return;
        }
      }
      let params = `deepseek#tokenMax#${this.ruleForm.tokenMax},deepseek#tokenWarn#${this.ruleForm.tokenWarn}`;
      this.$api.system.tokenSaveFn({dataList : params}).then(res=>{
        if(res.code == 1){
          this.$message.success("设置成功");
        }
      })
    },
    submitForm1() {
      if(this.ruleForm1.isLimitation){
        this.ruleForm1.tokenMax = 0;
        this.ruleForm1.tokenWarn = 0;
      }else{
        if(!this.ruleForm1.tokenMax){
          this.$message.error("请输入Token数");
          return;
        }
        if(!this.ruleForm1.tokenWarn){
          this.$message.error("请输入预警值");
          return;
        }
      }
      let params = `agent#tokenMax#${this.ruleForm1.tokenMax},agent#tokenWarn#${this.ruleForm1.tokenWarn}`;
      this.$api.system.tokenSaveFn({dataList : params}).then(res=>{
        if(res.code == 1){
          this.$message.success("设置成功");
        }
      })
    },

    /********************************
     * @value : 表单值 (若是不限制短信,设置字段为0,去除错误提示)
     *******************************/
    changeMaxNumber(value){
      if(value){
        this.ruleForm.tokenMax = 0;
        this.ruleForm.tokenWarn = 0;
      } else {
        this.ruleForm.tokenMax = this.tmpTokenMax;
        this.ruleForm.tokenWarn = this.tmpTokenWar;
      }
    },

    changeMaxNumber1(value){
      if(value){
        this.ruleForm1.tokenMax = 0;
        this.ruleForm1.tokenWarn = 0;
      } else {
        this.ruleForm1.tokenMax = this.tmpTokenMax1;
        this.ruleForm1.tokenWarn = this.tmpTokenWar1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.systemBox {
  background: #fff;
  padding: 20px 24px;
  border-radius: 8px !important;
  .topMargin{
    margin-top: 15px;
  }
  .el-form-item {
    /deep/ .el-form-item__content{
      padding-bottom: 0px;
      position: relative;
    }
  }
  .el-input{
    width:165px;
  }
  .el-form-item.isMaxNumber{
    /deep/ .el-input__inner {
      width:160px;
      padding: 0px 8px !important;
    }
  }

  .el-select.maxNumber {
    width: 90px;
    margin-right: 8px;
    /deep/ .el-input.el-input--suffix {
      width: 100%;
    }
    /deep/ .el-input__inner {
      width: 90px;
    }
  }
  .isMaxNumber {
    display: inline-block;
    /deep/ .el-form-item__content {
      .el-form-item__error{
        display: block;
      }
    }
  }
  .audit{
    margin-bottom: 34px;
  }
  .messageNumber-desc {
    display: inline-block;
    width: 72px;
    color : #737780;
  }
  .valueCss{
    color: cornflowerblue;
  }
  /deep/ .el-input-number__increase{
    line-height: 17px;
    height: 17px;
  }
}
</style>